<template>
<b-card title="Filtros">
  <div class="row filter-column" v-bind:class="{ 'showGrids': showFilterGrid }">
    <div class="col-md" v-bind:class="{ 'col-md-4': showFilterGrid }">
      <b-card-group columns>
        <b-card v-if="totalFilters===0">
          Sem filtros
        </b-card>
        <b-card v-show="filter.includes.length > 0 || filter.excludes.length > 0" no-body :key="filter.field" v-for="filter in readOptions.filters">
          <b-card-header>
            {{ filter.title }}
          </b-card-header>
          <b-list-group>
            <b-list-group-item variant="success" class="d-flex justify-content-between align-items-center" v-for="(item, index) in filter.includes" :key="item.id">
              {{ item.name }}
              <b-badge v-show="showFilterGrid" variant="danger" v-on:click="removeFilter(filter.field, index, 'includes')"><i class="fa fa-times"></i></b-badge>
            </b-list-group-item>
            <b-list-group-item variant="danger" class="d-flex justify-content-between align-items-center" v-for="(item, index) in filter.excludes" :key="item.id">
              {{ item.name }}
              <b-badge v-show="showFilterGrid" variant="danger" v-on:click="removeFilter(filter.field, index, 'excludes')"><i class="fa fa-times"></i>
              </b-badge>
            </b-list-group-item>
          </b-list-group>
          <b-card-footer>
            <a v-show="showFilterGrid" class="text-danger" v-on:click="removeAllFilters(filter.field)">Limpar filtros <i class="fa fa-ban"></i></a>
          </b-card-footer>
        </b-card>
      </b-card-group>
    </div>


    <div class="col-md-8" v-show="showFilterGrid">
      <b-card no-body>
        <b-card-header>
          <b-nav pills variant="secondary">
            <b-nav-item @click="changedFilter(filter.value, filter.name)" v-for="filter in filters" :key="filter.value" :active="type === filter.value">{{ filter.text }}</b-nav-item>
          </b-nav>
        </b-card-header>

        <DealersFilter v-show="type === 'dealer_id'" v-bind:filters="readOptions.filters" url="dealers" v-on:added-filter="addFilter" name="Distribuidor" field="dealer_id" />
        <DsrFilter v-show="type === 'dsr_id'"  v-bind:filters="readOptions.filters"   v-on:added-filter="addFilter" name="Vendedor" field="dsr_id" />
        <Product v-show="type === 'product_id'"  v-bind:filters="readOptions.filters"  url="products" v-on:added-filter="addFilter" name="Product" field="product_id" />
        <Prodaggreg v-show="type === 'prodaggreg_id'"  v-bind:filters="readOptions.filters"  url="prodaggregs" v-on:added-filter="addFilter" name="Prodaggreg" field="prodaggreg_id" />
        <GeneralFilter v-show="type === 'top10_id'"  v-bind:filters="readOptions.filters"  url="top10" v-on:added-filter="addFilter" name="Top UFS" field="top10_id" />
        <GeneralFilter v-show="type === 'product_category_id'"  v-bind:filters="readOptions.filters"  url="product_categories" v-on:added-filter="addFilter" name="Categoria" field="product_category_id" />

        <OperatorsFilter v-show="type === 'operator_id'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />
        <ZonesFilter v-show="type === 'zone'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />
        <SOFilter v-show="type === 'stars_so_code'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />
        <CHAFilter v-show="type === 'stars_cha_code'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />
        <STFilter v-show="type === 'stars_st_code'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />
        <CADVFilter v-show="type === 'stars_cadv_code'"  v-bind:filters="readOptions.filters"  v-on:added-filter="addFilter" />

      </b-card>
    </div>
  </div>
</b-card>
</template>

<script>
import GeneralFilter from '@/views/Filters/Filter.vue'
import DealersFilter from '@/views/Filters/DealersFilter.vue'
import Prodaggreg from '@/views/Filters/ProdAgregFilter.vue'
import Product from '@/views/Filters/ProductFilter.vue'
import OperatorsFilter from '@/views/Filters/OperatorsFilter.vue'
import ZonesFilter from '@/views/Filters/ZonesFilter.vue'
import DsrFilter from '@/views/Filters/DsrFilter.vue'
import SOFilter from '@/views/Filters/SOFilter.vue'
import CHAFilter from '@/views/Filters/CHAFilter.vue'
import CADVFilter from '@/views/Filters/CADVFilter.vue'
import STFilter from '@/views/Filters/STFilter.vue'

export default {
  name: 'Filters',
  components: {
    GeneralFilter,
    Prodaggreg,
    Product,
    OperatorsFilter,
    ZonesFilter,
    DsrFilter,
    SOFilter,
    CHAFilter,
    CADVFilter,
    STFilter,
    DealersFilter
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data() {
    return {
      type: null,
      name: ''
    }
  },
  methods: {
    changedFilter(field, name) {
      this.type = field
      this.name = name
    },
    removeBeforeAdding(evt) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          for (let w = 0; w < this.readOptions.filters[i]['includes'].length; w++) {
            if (evt.item.id === this.readOptions.filters[i]['includes'][w].id) {
              this.readOptions.filters[i]['includes'].splice(w, 1)
            }
          }
          for (let w = 0; w < this.readOptions.filters[i]['excludes'].length; w++) {
            if (evt.item.id === this.readOptions.filters[i]['excludes'][w].id) {
              this.readOptions.filters[i]['excludes'].splice(w, 1)
            }
          }
          break
        }
      }
    },
    addFilter(evt) {
      var start = window.performance.now()
      console.log('event received', start)
      var found = false
      this.removeBeforeAdding(evt)
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          })
          found = true
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          })
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          })
        }
      }
      console.log('added to list', window.performance.now())
      console.log('added to list elapsed', window.performance.now() - start)
    },
    removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1)
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1)
          }
        }
      }
    },
    removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = []
          this.readOptions.filters[i].excludes = []
        }
      }
    }
  },
  created() {
    console.log('FIlters', this.filters)
  }
}
</script>



// WEBPACK FOOTER //
// Filters.vue?21bab828